import React from 'react';
import {useNavigate} from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';
import {Container, LogoWrapper, SwitcherWrapper} from './LogoWithLanguageSwitcher.styled';
import Manual from "./Manual";
import {languages} from "../../config/languages";

interface LogoWithLanguageSwitcherProps {
    src: string;
    alt: string;
    clickable?: boolean;
}

const LogoWithLanguageSwitcher = ({src, alt, clickable = false}: LogoWithLanguageSwitcherProps) => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        if (clickable) {
            navigate('/login');
        }
    };

    const languageList = languages.filter(lang => lang.forInterface);

    return (
        <Container>
            <LogoWrapper $clickable={clickable ?? false} onClick={handleLogoClick}>
                <img src={src} alt={alt}/>
            </LogoWrapper>

            <SwitcherWrapper>
                <LanguageSwitcher languageList={languageList}/>
                <Manual/>
            </SwitcherWrapper>
        </Container>
    );
};

export default LogoWithLanguageSwitcher;
